import { de as deDE } from 'date-fns/locale';
import { enUS } from 'date-fns/locale';
import type { Locale } from 'date-fns';
import { currentLanguage } from './translator';

/**
 * Maps app locale codes to date-fns Locale objects
 * Supports: de_CH (maps to de), de_DE (maps to de), en_US (maps to enUS)
 */
export function getDatepickerLocale(locale?: string): Locale {
  const lang = locale || currentLanguage;

  // Extract language part (e.g., "de_CH" -> "de")
  const langCode = lang.split('_')[0];

  switch (langCode) {
    case 'de':
      return deDE;
    case 'en':
      return enUS;
    default:
      return enUS;
  }
}

export { currentLanguage };
